import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Layers, ArrowRightLeft, Compass } from 'lucide-react';
const variants = [{
  id: 'step-flow',
  path: '/step-flow',
  name: 'Step Flow',
  shortcut: '1',
  icon: Layers,
  description: 'Sequential guided journey'
}, {
  id: 'quick-nav',
  path: '/quick-nav',
  name: 'Quick Nav',
  shortcut: '2',
  icon: ArrowRightLeft,
  description: 'One-tap everything, controls always visible'
}, {
  id: 'overview',
  path: '/overview',
  name: 'Overview',
  shortcut: '3',
  icon: Compass,
  description: 'Full catalog at a glance'
}];
export function VariantSwitcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Don't trigger if user is typing in an input
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLTextAreaElement) return;
      const variant = variants.find(v => v.shortcut === e.key);
      if (variant && currentPath !== variant.path) {
        navigate(variant.path);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [navigate, currentPath]);
  return <div className="hidden md:flex flex-col gap-2 w-[200px] shrink-0" data-id="element-2145">
      <div className="text-white/30 text-[10px] uppercase tracking-widest font-semibold mb-1 px-1" data-id="element-2146">
        Layout Variants
      </div>
      {variants.map(variant => {
      const Icon = variant.icon;
      const isActive = currentPath === variant.path;
      return <motion.button key={variant.id} onClick={() => navigate(variant.path)} whileTap={{
        scale: 0.97
      }} className={`relative flex items-start gap-3 px-3 py-3 rounded-xl text-left transition-all ${isActive ? 'bg-white/10 ring-1 ring-white/20' : 'bg-white/[0.03] hover:bg-white/[0.06] ring-1 ring-white/5'}`} data-id="element-2147">
            <div className={`w-8 h-8 rounded-lg flex items-center justify-center shrink-0 ${isActive ? 'bg-blue-500 text-white' : 'bg-white/10 text-white/50'}`} data-id="element-2148">
              <Icon className="w-4 h-4" data-id="element-2149" />
            </div>
            <div className="flex-1 min-w-0" data-id="element-2150">
              <div className="flex items-center gap-2" data-id="element-2151">
                <span className={`text-sm font-semibold ${isActive ? 'text-white' : 'text-white/70'}`} data-id="element-2152">
                  {variant.name}
                </span>
                <kbd className="text-[9px] font-mono bg-white/10 text-white/40 px-1.5 py-0.5 rounded border border-white/10" data-id="element-2153">
                  {variant.shortcut}
                </kbd>
              </div>
              <span className="text-[11px] text-white/35 leading-tight" data-id="element-2154">
                {variant.description}
              </span>
            </div>
            {isActive && <motion.div layoutId="variant-indicator" className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-blue-500 rounded-r-full" transition={{
          type: 'spring',
          damping: 25,
          stiffness: 300
        }} data-id="element-2155" />}
          </motion.button>;
    })}
      <div className="mt-2 px-1 text-[10px] text-white/20" data-id="element-2156">
        Press{' '}
        <kbd className="font-mono bg-white/10 px-1 py-0.5 rounded text-white/30" data-id="element-2157">
          1
        </kbd>{' '}
        <kbd className="font-mono bg-white/10 px-1 py-0.5 rounded text-white/30" data-id="element-2158">
          2
        </kbd>{' '}
        <kbd className="font-mono bg-white/10 px-1 py-0.5 rounded text-white/30" data-id="element-2159">
          3
        </kbd>{' '}
        to switch
      </div>
    </div>;
}